import { useCallback } from 'react';

import { SelectedAction } from '@hsp/react-component-library';

import { useClientGroupColumns } from '@p/security/users/client-group/hooks/columns/client-group-colums';
import { userStore } from '@p/security/users/store/store';

import { IClientGroup } from '@t/user/client-group.model';
import { AddClientGroupForm } from '@t/user/components/clientGroupFilter/field-values.schema';

export const useClientGroupConfiguration = () => {
  const { setIsOpenClientGroup, isOpenClientGroup } = userStore();
  const handleAction = useCallback(({ action }: SelectedAction<IClientGroup>) => {
    switch (action) {
      case 'edit':
        break;

      case 'remove':
        break;
    }
  }, []);
  const handleSubmitted = useCallback((formData: AddClientGroupForm) => {
    formData;
  }, []);

  const columns = useClientGroupColumns(handleAction);

  return {
    columns,
    handleSubmitted,
    isOpenClientGroup,
    setIsOpenClientGroup,
  };
};
